import React from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { Badge } from "react-bootstrap";
import CustomFieldHelper from "../../_Helpers/CustomFieldHelper";
import * as compensationEventCrud from '../../../../crud/compensationEvent.crud';
import { notificationUniqueTagsFilterV3 } from "../../../../store/helpers/FilterHelper";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import { getCENBadgeVariantByStatus } from '../compensation/ListAll';
import BaseListPage from '../../_CustomComponents/BaseListPage';


export const getBatchFormFields = (fields, replyFields, intl) => {
    const formFields = [];
    if (fields.ProposedVariation.visible) {
        formFields.push({
            caption: fields.ProposedVariation.label,
            dataField: 'proposedcenreference',
            required: fields.ProposedVariation.required,
            dataType: 'string',
        })
    }

    if (fields.Subject.visible) {
        formFields.push({
            caption: fields.Subject.label,
            dataField: 'compensationnumber',
            required: fields.Subject.required,
            dataType: 'string',
        })
    }

    if (fields.CompensationType.visible) {
        formFields.push({
            caption: fields.CompensationType.label,
            dataField: 'compensationtype',
            required: fields.CompensationType.required,
            dataType: 'list',
            options: {
                dataSource: fields.CompensationType.clauses,
                valueExpr: 'display',
                displayExpr: 'display'
            }
        })
    }

    if (fields.PriceEffect.visible) {
        formFields.push({
            caption: fields.PriceEffect.label,
            dataField: 'assessmentamount',
            required: fields.PriceEffect.required,
            dataType: 'money',
        })
    }

    if (fields.TimeEffect.visible) {
        formFields.push({
            caption: fields.TimeEffect.label,
            dataField: 'alternativequotation',
            required: fields.TimeEffect.required,
            dataType: 'integer',
        })
    }


    if (fields.Details.visible) {
        formFields.push({
            caption: fields.Details.label,
            dataField: 'description',
            required: fields.Details.required,
            dataType: 'long-string',
        })
    }

    return formFields;
}


class VariationOrderListPage extends BaseListPage {
    constructor(props) {
        super(props);

        this.notificationsTagsEnabled = process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true' && props.contract.specifictags?.length > 0;
        this.notificationsRelsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true';
        this.customFields = [];
        if (props.customFields) {
            if (props.customFields.COMMUNICATION && props.customFields.COMMUNICATION.length > 0) {
                this.customFields.push(...(props.customFields.COMMUNICATION.filter(cf => cf.includelisting)));
            }
            if (props.customFields.REPLY && props.customFields.REPLY.length > 0) {
                this.customFields.push(...(props.customFields.REPLY.filter(cf => cf.includelisting)));
            }
        }


        this.batchFormFields = getBatchFormFields(this.props.workflowItem.fields, this.props.workflowItem.replyFields, this.props.intl);



        this.state = {
            notifications: null,
            columns: null,
        };
    }

    formatCurrency = () => {
        return this.props.contract.currency
    }
    getColumns = (tagFilters) => {
        const { fields } = this.props.workflowItem;
        const gridColumns = [
            { resource: "GENERAL.FORMS.FIELD.ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
            { caption: "Proposed Variation ID", dataField: "proposedcenreference", dataType: 'string' },
            { resource: "GENERAL.FORMS.FIELD.SUBJECT", dataField: 'compensationnumber' },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_DATE", dataField: "notificationdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_BY", dataField: "communicatedby" },
        ];
        if (fields.PriceEffect.visible) {
            gridColumns.push({ resource: "GENERAL.FORMS.FIELD.AMOUNT", dataField: 'assessmentamount', dataType: 'currency', currencyCode: this.props.contract.currency });
        }
        if (fields.TimeEffect.visible) {
            gridColumns.push({ resource: "GENERAL.FORMS.FIELD.DAYS", dataField: 'alternativequotation', dataType: 'string' });
        }
        gridColumns.push(
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "replystatus", cellRender: this.renderStatusColumn, calculateCellValue: this.renderStatusDisplay },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
            { resource: "GENERAL.FORMS.FIELD.CURRENCY", dataField: "currency", visible: false, calculateCellValue: this.formatCurrency },
            { resource: "PROJECT.FIELD.CODE", dataField: "projectcode", visible: false },
            { resource: "PROJECT.FIELD.NAME", dataField: "project", visible: false },
            { resource: "GENERAL.FORMS.FIELD.CREATED_BY", dataField: "createby", visible: false },
            { resource: "GENERAL.FORMS.FIELD.DRAFT_NOTIFIED_TO", dataField: "lastdraftednotifiedtoname", visible: false },

        );

        if (this.props.workflowItem.assetFieldsEnabled) {
            gridColumns.push(
                { resource: "GENERAL.FORMS.FIELD.ASSET_NAME", dataField: "assetname", visible: false },
                { resource: "GENERAL.FORMS.FIELD.ASSET_TYPE", dataField: "assettype", visible: false },
            );
        }
        if (this.notificationsTagsEnabled) {
            gridColumns.push(
                { resource: "GENERAL.FORMS.FIELD.PORTFOLIO", dataField: "tags_portfolio", visible: false, dataType: 'tag', headerFilter: { dataSource: tagFilters.PortfolioFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROGRAMME", dataField: "tags_programme", visible: false, dataType: 'tag', headerFilter: { dataSource: tagFilters.ProgrammeFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROJECT", dataField: "tags_project", visible: false, dataType: 'tag', headerFilter: { dataSource: tagFilters.ProjectFilter } },
                { resource: "GENERAL.FORMS.FIELD.OTHER", dataField: "tags_other", visible: false, dataType: 'tag', headerFilter: { dataSource: tagFilters.OtherFilter } }
            )
        }
        if (this.notificationsRelsEnabled) {
            gridColumns.push(
                { resource: "GENERAL.FORMS.TAB_RELATIONS", dataField: "relatednotices", visible: false },
            )
        }
        gridColumns.push(...CustomFieldHelper.MapCustomFieldsToDataGridColumns(this.customFields));
        return gridColumns;

    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchCompensationEvents();
    }

    fetchCompensationEvents = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data: responseObj } = await compensationEventCrud.getCompansationEventsReduced2(
                companyid,
                projectid,
                contractid,
                this.props.workflowItem.config.currentModelType,
                this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed,
                this.props.accessibleWfIds);
            let notifications = CustomFieldHelper.MapDataListCustomFieldsToObjectPropertiesV2(responseObj);
            let tagFilters = notificationUniqueTagsFilterV3(this.props.communicationTags);
            let columns = this.getColumns(tagFilters);
            this.setState({ notifications, columns });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }



    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            const url = this.calculateUrl(data, true);
            this.props.navigate(url);
        }
    }
    calculateUrl = (rowData, skipHostUrl) => {
        return (skipHostUrl ? '' : process.env.PUBLIC_URL) + this.props.workflowItem.paths.basePath + rowData.compensationeventid;
    }
    renderStatusColumn = (cellInfo) => {
        let badgeVariant = getCENBadgeVariantByStatus(cellInfo.data.status);
        let status = this.renderStatusDisplay(cellInfo.data);
        return (<Badge variant={badgeVariant}>{status}</Badge>);
    }
    renderStatusDisplay = (rowData) => {
        const status = this.props.placeholdersQA.CompensationStatuses?.values.find(x => x.field === rowData.status);
        if (status) {
            return status.display;
        } else {
            return rowData.status;
        }
    }

    render() {
        if (!this.state.notifications) {
            return (<PortletSpinner />);
        }


        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="2"
                        //BATCH OPS
                        batchOperations={false}
                        batchFormFields={this.batchFormFields}
                        batchImportEndpoint={compensationEventCrud.importCompensationEvents}
                        batchDeleteEndpoint={compensationEventCrud.deleteCompensationEventDrafts}
                        batchCommunicateEndpoint={compensationEventCrud.communicateCompensationEventDrafts}
                        onBatchRecordsUpdated={this.fetchCompensationEvents}
                        customFields={this.props.customFields}
                        //BATCH OPS
                        title={this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.TITLE2' }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                        createPath={this.props.workflowItem.userFilters.mainNotice.createAllowed ? this.props.workflowItem.paths.createPath : null}
                        workflowItem={this.props.workflowItem}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.notifications}
                        keyExpr="compensationeventid"
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        columns={this.state.columns}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}



export default withListPageProps(VariationOrderListPage);
